module.exports = __webpack_public_path__ + "img/涡扇炮智能消防车@1x.ba310043.png";